import { ContainerPage, TitlePage } from "components";
import { OptionsMenu } from "components/OptionsMenu";
import { useTableParams } from "hooks/useTableParams";
import React, { useRef, useMemo, useState } from "react";
import { MdModeEditOutline } from "react-icons/md";
import storageService from "services/storageService";
import { Table } from "shared";
import { convertDate, mapType } from "utils";

import { Unlock } from "./Unlock";
const mapBlockedStockData = data => {
  if (!Array.isArray(data)) {
    return [];
  }

  const mapped = data.map(item => ({
    id: item.id,
    batch_id: item.storage.batch_id,
    product_base_name: item.storage.product_base.name,
    locked_stock: item.quantity,
    input_type_id: item.input_type_id,
    created: item.created
  }));

  return mapped;
};

export default function BlockedStock() {
  const unlockRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { data, onChange, params, refresh, status, count, handleSearch } =
    useTableParams({
      service: params => storageService.getAllLockedStorage(params)
    });

  const mappedData = useMemo(() => {
    if (status === "pending") {
      return [];
    }
    const mapped = mapBlockedStockData(data);

    if (!searchTerm) {
      return mapped;
    }

    return mapped.filter(item =>
      item.product_base_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [data, status, searchTerm]);

  const options = [
    {
      title: "Desbloquear",
      icon: MdModeEditOutline,
      permissions: ["Estoque", "Estoque físico", "Tech", "Previsão"],
      action: data => unlockRef.current.handleData(data)
    }
  ];

  const columns = [
    {
      field: "created",
      label: "Criado em",
      align: "center",
      disabledSort: true,
      style: { minWidth: "150px" },
      formatter: value => convertDate(new Date(value))
    },
    {
      field: "id",
      label: "Id",
      align: "center",
      style: { minWidth: "120px" }
    },
    {
      field: "batch_id",
      label: "Lote",
      style: { minWidth: "120px" }
    },
    {
      field: "product_base_name",
      label: "Produto",
      style: { minWidth: "240px" }
    },
    {
      field: "locked_stock",
      label: "Qtd. bloqueada",
      align: "center",
      style: { minWidth: "170px" }
    },
    {
      field: "input_type_id",
      label: "Tipo de entrada",
      align: "center",
      style: { minWidth: "180px" },
      formatter: value => mapType(value)
    },
    {
      field: "delete",
      label: "",
      align: "right",
      style: { minWidth: "150px" },
      renderCell: ({ data }) => <OptionsMenu data={data} options={options} />
    }
  ];

  return (
    <>
      <ContainerPage>
        <TitlePage>Estoque bloqueado</TitlePage>

        <Table
          handleSearch={handleSearch}
          columns={columns}
          data={mappedData}
          onChange={onChange}
          params={params}
          status={status}
          refresh={refresh}
          count={count}
          size="small"
          placeholder="Produto base"
        />
      </ContainerPage>

      <Unlock refresh={refresh} ref={unlockRef} />
    </>
  );
}
